import { t } from 'i18next';
import { DateUtils } from '../../utils/DateUtils';
import { GQLIdEncoder } from '../../utils/GQLIdEncoder';
import { TlsHandshake } from '../models/TlsHandshake';

export class TlsHandshakeMapper {
  private readonly gqlIdEncoder = new GQLIdEncoder();

  mapGQLModel(data: any): TlsHandshake {
    return new TlsHandshake(
      this.gqlIdEncoder.decode(data.id),
      data.initiatorIp,
      data.targetIp,
      data.initiatorPort,
      data.targetPort,
      data.timestamp ? DateUtils.toMoment(data.timestamp) : null,
      data.status,
      data.serverNameIndication,
      data.selectedCiphersuite?.name || t('n/a'),
      data.serverChosenVersion
    );
  }
}
